// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModernVideoModelNode-container {
  --video-accent: #a95440;
  --video-soft: #f7ece8;
  position: relative;
  width: 368px;
  overflow: visible;
  border: 1px solid color-mix(in srgb, var(--video-accent) 22%, #dde1e7);
  border-radius: 18px;
  background: #fcfcfa;
  box-shadow: 0 16px 42px rgba(31, 42, 57, 0.11), 0 2px 8px rgba(31, 42, 57, 0.05);
  color: #1c222c;
  font-family: Inter, "PingFang SC", "Microsoft YaHei", sans-serif;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.ModernVideoModelNode-container:hover {
  border-color: color-mix(in srgb, var(--video-accent) 42%, #d8dde4);
  box-shadow: 0 20px 48px rgba(31, 42, 57, 0.14), 0 2px 8px rgba(31, 42, 57, 0.06);
}

.ModernVideoModelNode-header {
  display: flex;
  min-height: 78px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 18px 14px 21px;
  border-bottom: 1px solid color-mix(in srgb, var(--video-accent) 12%, #e4e7eb);
  border-radius: 17px 17px 0 0;
  background: linear-gradient(118deg, var(--video-soft) 0%, color-mix(in srgb, var(--video-soft) 48%, #fff) 58%, #fcfcfa 100%);
  color: #18202c;
}

.ModernVideoModelNode-brand {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 11px;
}

.ModernVideoModelNode-icon {
  display: grid;
  width: 39px;
  height: 39px;
  flex: 0 0 39px;
  place-items: center;
  border: 1px solid color-mix(in srgb, var(--video-accent) 42%, #fff);
  border-radius: 11px;
  background: linear-gradient(145deg, color-mix(in srgb, var(--video-accent) 84%, #fff), var(--video-accent));
  box-shadow: 0 7px 16px color-mix(in srgb, var(--video-accent) 18%, transparent);
  color: #fff;
  font-size: 20px;
  line-height: 1;
}

.ModernVideoModelNode-title {
  overflow: hidden;
  color: #18202c;
  font-size: 16px;
  font-weight: 760;
  letter-spacing: -0.02em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ModernVideoModelNode-model-id {
  margin-top: 3px;
  color: color-mix(in srgb, var(--video-accent) 72%, #56606e);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.ModernVideoModelNode-reference-cap {
  flex: 0 0 auto;
  padding: 5px 8px;
  border: 1px solid color-mix(in srgb, var(--video-accent) 24%, #dfe3e8);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.72);
  color: var(--video-accent);
  font-size: 10px;
  font-weight: 750;
}

.ModernVideoModelNode-reference-caps {
  display: grid;
  flex: 0 0 auto;
  gap: 5px;
  justify-items: end;
}

.ModernVideoModelNode-reference-cap-video {
  color: #6f4d87;
}

.ModernVideoModelNode-reference-cap-audio {
  color: #b45d13;
}

.ModernVideoModelNode-body {
  display: grid;
  gap: 12px;
  padding: 15px 18px 18px 21px;
}

.ModernVideoModelNode-status-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.ModernVideoModelNode-status-row span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 8px;
  border-radius: 7px;
  background: #f0f2f4;
  color: #747d8b;
  font-size: 11px;
  font-weight: 680;
}

.ModernVideoModelNode-status-row span.is-ready {
  background: var(--video-soft);
  color: var(--video-accent);
}

.ModernVideoModelNode-reference-strip {
  display: flex;
  min-height: 34px;
  align-items: center;
  gap: 5px;
  padding: 6px 8px;
  border: 1px dashed color-mix(in srgb, var(--video-accent) 22%, #d1d6dd);
  border-radius: 9px;
  background: color-mix(in srgb, var(--video-soft) 38%, #fff);
}

.ModernVideoModelNode-reference-strip span,
.ModernVideoModelNode-reference-strip em {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  border-radius: 6px;
  background: var(--video-accent);
  color: #fff;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
}

.ModernVideoModelNode-reference-strip small {
  color: #77808d;
  font-size: 10px;
  line-height: 1.35;
}

.ModernVideoModelNode-video-strip {
  background: color-mix(in srgb, #efe8f4 55%, #fff);
  border-color: color-mix(in srgb, #74538a 28%, #d1d6dd);
}

.ModernVideoModelNode-video-strip span {
  display: inline-flex;
  width: auto;
  min-width: 34px;
  gap: 2px;
  padding: 0 6px;
  background: #74538a;
}

.ModernVideoModelNode-video-handle {
  background: #74538a !important;
}

.ModernVideoModelNode-audio-strip {
  background: color-mix(in srgb, #fff0dc 58%, #fff);
  border-color: color-mix(in srgb, #c56c1b 30%, #d1d6dd);
}

.ModernVideoModelNode-audio-strip span {
  display: inline-flex;
  width: auto;
  min-width: 34px;
  gap: 3px;
  padding: 0 6px;
  background: #c56c1b;
}

.ModernVideoModelNode-audio-handle {
  background: #c56c1b !important;
}

.ModernVideoModelNode-field {
  display: grid;
  grid-template-columns: 78px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  margin: 0;
}

.ModernVideoModelNode-field > span {
  color: #59616e;
  font-size: 12px;
  font-weight: 680;
}

.ModernVideoModelNode-field select {
  width: 100%;
  height: 34px;
  padding: 0 30px 0 10px;
  border: 1px solid #d9dde4;
  border-radius: 8px;
  outline: 0;
  background: #fff;
  color: #252c37;
  font-size: 12px;
}

.ModernVideoModelNode-field select:focus {
  border-color: var(--video-accent);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--video-accent) 11%, transparent);
}

.ModernVideoModelNode-duration-field {
  align-items: start;
}

.ModernVideoModelNode-duration-field > span {
  padding-top: 5px;
}

.ModernVideoModelNode-duration-control {
  min-width: 0;
}

.ModernVideoModelNode-duration-slider-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ModernVideoModelNode-duration-slider {
  width: 100%;
  min-width: 0;
  height: 22px;
  margin: 0;
  appearance: none;
  outline: 0;
  background: transparent;
  cursor: pointer;
}

.ModernVideoModelNode-duration-slider::-webkit-slider-runnable-track {
  height: 5px;
  border-radius: 999px;
  background: linear-gradient(
    to right,
    var(--video-accent) 0%,
    var(--video-accent) var(--duration-progress),
    #dfe3e8 var(--duration-progress),
    #dfe3e8 100%
  );
}

.ModernVideoModelNode-duration-slider::-webkit-slider-thumb {
  width: 16px;
  height: 16px;
  margin-top: -5.5px;
  appearance: none;
  border: 3px solid #fff;
  border-radius: 50%;
  background: var(--video-accent);
  box-shadow: 0 0 0 1px var(--video-accent), 0 2px 5px rgba(31, 42, 57, 0.18);
}

.ModernVideoModelNode-duration-slider::-moz-range-track {
  height: 5px;
  border-radius: 999px;
  background: #dfe3e8;
}

.ModernVideoModelNode-duration-slider::-moz-range-progress {
  height: 5px;
  border-radius: 999px;
  background: var(--video-accent);
}

.ModernVideoModelNode-duration-slider::-moz-range-thumb {
  width: 10px;
  height: 10px;
  border: 3px solid #fff;
  border-radius: 50%;
  background: var(--video-accent);
  box-shadow: 0 0 0 1px var(--video-accent), 0 2px 5px rgba(31, 42, 57, 0.18);
}

.ModernVideoModelNode-duration-slider:focus-visible::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px var(--video-accent), 0 0 0 4px color-mix(in srgb, var(--video-accent) 16%, transparent);
}

.ModernVideoModelNode-duration-slider:focus-visible::-moz-range-thumb {
  box-shadow: 0 0 0 1px var(--video-accent), 0 0 0 4px color-mix(in srgb, var(--video-accent) 16%, transparent);
}

.ModernVideoModelNode-duration-value {
  min-width: 48px;
  padding: 4px 7px;
  border: 1px solid color-mix(in srgb, var(--video-accent) 25%, #dfe3e8);
  border-radius: 7px;
  background: var(--video-soft);
  color: var(--video-accent);
  font-size: 11px;
  font-weight: 750;
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
}

.ModernVideoModelNode-duration-limits {
  display: flex;
  justify-content: space-between;
  margin-top: -1px;
  padding-right: 58px;
  color: #9299a4;
  font-size: 9px;
  line-height: 1;
}

.ModernVideoModelNode-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 9px 10px;
  border: 1px solid #dfe2e7;
  border-radius: 9px;
  background: #f4f5f6;
  color: #3e4652;
  font-size: 12px;
  font-weight: 680;
  cursor: pointer;
}

.ModernVideoModelNode-toggle input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: var(--video-accent);
}

.ModernVideoModelNode-hint {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  padding: 9px 10px;
  border-left: 3px solid color-mix(in srgb, var(--video-accent) 82%, #fff);
  border-radius: 7px;
  background: var(--video-soft);
  color: #58606c;
  font-size: 10px;
  line-height: 1.45;
}

.ModernVideoModelNode-hint i {
  flex: 0 0 auto;
  color: var(--video-accent);
}

.ModernVideoModelNode-error {
  padding: 8px 10px;
  border: 1px solid #ffd0cd;
  border-radius: 8px;
  background: #fff2f1;
  color: #b42318;
  font-size: 11px;
}

.ModernVideoModelNode-generate {
  display: inline-flex;
  min-height: 43px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  border-radius: 10px;
  background: linear-gradient(135deg, color-mix(in srgb, var(--video-accent) 96%, #fff), color-mix(in srgb, var(--video-accent) 88%, #283744));
  box-shadow: 0 8px 18px color-mix(in srgb, var(--video-accent) 17%, transparent);
  color: #fff;
  font-size: 13px;
  font-weight: 760;
  cursor: pointer;
}

.ModernVideoModelNode-generate:hover:not(:disabled) {
  filter: brightness(0.97) saturate(1.04);
  transform: translateY(-1px);
}

.ModernVideoModelNode-generate:disabled,
.ModernVideoModelNode-field select:disabled,
.ModernVideoModelNode-duration-slider:disabled {
  cursor: not-allowed;
  opacity: 0.58;
}

.ModernVideoModelNode-duplicate {
  position: absolute;
  z-index: 4;
  top: -12px;
  right: -12px;
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  border: 1px solid #dfe3e8;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 5px 14px rgba(25, 31, 43, 0.15);
  color: #505966;
  cursor: pointer;
}

.ModernVideoModelNode-handle {
  width: 11px !important;
  height: 11px !important;
  border: 2px solid #fff !important;
  background: var(--video-accent) !important;
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--video-accent) 36%, #d2d7de);
}

.ModernVideoModelNode-handle-label {
  position: absolute;
  top: 50%;
  right: 13px;
  width: max-content;
  padding: 3px 7px;
  transform: translateY(-50%);
  border: 1px solid #dce1e7;
  border-radius: 7px;
  background: #fff;
  color: #59616e;
  font-size: 10px;
  font-weight: 720;
  cursor: pointer;
}

.ModernVideoModelNode-spinner {
  width: 13px;
  height: 13px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: ModernVideoModelNode-spin 0.8s linear infinite;
}

@keyframes ModernVideoModelNode-spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/ModernVideoModelNode.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,sEAAsE;EACtE,mBAAmB;EACnB,mBAAmB;EACnB,gFAAgF;EAChF,cAAc;EACd,gEAAgE;EAChE,0DAA0D;AAC5D;;AAEA;EACE,kEAAkE;EAClE,gFAAgF;AAClF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,4BAA4B;EAC5B,6EAA6E;EAC7E,4BAA4B;EAC5B,4HAA4H;EAC5H,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mEAAmE;EACnE,mBAAmB;EACnB,2GAA2G;EAC3G,+EAA+E;EAC/E,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2DAA2D;EAC3D,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sEAAsE;EACtE,oBAAoB;EACpB,qCAAqC;EACrC,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uEAAuE;EACvE,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iDAAiD;EACjD,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,QAAQ;EACR,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iDAAiD;EACjD,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,QAAQ;EACR,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,8EAA8E;AAChF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB;;;;;;GAMC;AACH;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,2EAA2E;AAC7E;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,2EAA2E;AAC7E;;AAEA;EACE,6GAA6G;AAC/G;;AAEA;EACE,6GAA6G;AAC/G;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sEAAsE;EACtE,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,wEAAwE;EACxE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,4IAA4I;EAC5I,+EAA+E;EAC/E,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;EAC7C,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,0CAA0C;EAC1C,0EAA0E;AAC5E;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".ModernVideoModelNode-container {\n  --video-accent: #a95440;\n  --video-soft: #f7ece8;\n  position: relative;\n  width: 368px;\n  overflow: visible;\n  border: 1px solid color-mix(in srgb, var(--video-accent) 22%, #dde1e7);\n  border-radius: 18px;\n  background: #fcfcfa;\n  box-shadow: 0 16px 42px rgba(31, 42, 57, 0.11), 0 2px 8px rgba(31, 42, 57, 0.05);\n  color: #1c222c;\n  font-family: Inter, \"PingFang SC\", \"Microsoft YaHei\", sans-serif;\n  transition: border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.ModernVideoModelNode-container:hover {\n  border-color: color-mix(in srgb, var(--video-accent) 42%, #d8dde4);\n  box-shadow: 0 20px 48px rgba(31, 42, 57, 0.14), 0 2px 8px rgba(31, 42, 57, 0.06);\n}\n\n.ModernVideoModelNode-header {\n  display: flex;\n  min-height: 78px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 18px 14px 21px;\n  border-bottom: 1px solid color-mix(in srgb, var(--video-accent) 12%, #e4e7eb);\n  border-radius: 17px 17px 0 0;\n  background: linear-gradient(118deg, var(--video-soft) 0%, color-mix(in srgb, var(--video-soft) 48%, #fff) 58%, #fcfcfa 100%);\n  color: #18202c;\n}\n\n.ModernVideoModelNode-brand {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 11px;\n}\n\n.ModernVideoModelNode-icon {\n  display: grid;\n  width: 39px;\n  height: 39px;\n  flex: 0 0 39px;\n  place-items: center;\n  border: 1px solid color-mix(in srgb, var(--video-accent) 42%, #fff);\n  border-radius: 11px;\n  background: linear-gradient(145deg, color-mix(in srgb, var(--video-accent) 84%, #fff), var(--video-accent));\n  box-shadow: 0 7px 16px color-mix(in srgb, var(--video-accent) 18%, transparent);\n  color: #fff;\n  font-size: 20px;\n  line-height: 1;\n}\n\n.ModernVideoModelNode-title {\n  overflow: hidden;\n  color: #18202c;\n  font-size: 16px;\n  font-weight: 760;\n  letter-spacing: -0.02em;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ModernVideoModelNode-model-id {\n  margin-top: 3px;\n  color: color-mix(in srgb, var(--video-accent) 72%, #56606e);\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n}\n\n.ModernVideoModelNode-reference-cap {\n  flex: 0 0 auto;\n  padding: 5px 8px;\n  border: 1px solid color-mix(in srgb, var(--video-accent) 24%, #dfe3e8);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.72);\n  color: var(--video-accent);\n  font-size: 10px;\n  font-weight: 750;\n}\n\n.ModernVideoModelNode-reference-caps {\n  display: grid;\n  flex: 0 0 auto;\n  gap: 5px;\n  justify-items: end;\n}\n\n.ModernVideoModelNode-reference-cap-video {\n  color: #6f4d87;\n}\n\n.ModernVideoModelNode-reference-cap-audio {\n  color: #b45d13;\n}\n\n.ModernVideoModelNode-body {\n  display: grid;\n  gap: 12px;\n  padding: 15px 18px 18px 21px;\n}\n\n.ModernVideoModelNode-status-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.ModernVideoModelNode-status-row span {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 8px;\n  border-radius: 7px;\n  background: #f0f2f4;\n  color: #747d8b;\n  font-size: 11px;\n  font-weight: 680;\n}\n\n.ModernVideoModelNode-status-row span.is-ready {\n  background: var(--video-soft);\n  color: var(--video-accent);\n}\n\n.ModernVideoModelNode-reference-strip {\n  display: flex;\n  min-height: 34px;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 8px;\n  border: 1px dashed color-mix(in srgb, var(--video-accent) 22%, #d1d6dd);\n  border-radius: 9px;\n  background: color-mix(in srgb, var(--video-soft) 38%, #fff);\n}\n\n.ModernVideoModelNode-reference-strip span,\n.ModernVideoModelNode-reference-strip em {\n  display: grid;\n  width: 22px;\n  height: 22px;\n  place-items: center;\n  border-radius: 6px;\n  background: var(--video-accent);\n  color: #fff;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 800;\n}\n\n.ModernVideoModelNode-reference-strip small {\n  color: #77808d;\n  font-size: 10px;\n  line-height: 1.35;\n}\n\n.ModernVideoModelNode-video-strip {\n  background: color-mix(in srgb, #efe8f4 55%, #fff);\n  border-color: color-mix(in srgb, #74538a 28%, #d1d6dd);\n}\n\n.ModernVideoModelNode-video-strip span {\n  display: inline-flex;\n  width: auto;\n  min-width: 34px;\n  gap: 2px;\n  padding: 0 6px;\n  background: #74538a;\n}\n\n.ModernVideoModelNode-video-handle {\n  background: #74538a !important;\n}\n\n.ModernVideoModelNode-audio-strip {\n  background: color-mix(in srgb, #fff0dc 58%, #fff);\n  border-color: color-mix(in srgb, #c56c1b 30%, #d1d6dd);\n}\n\n.ModernVideoModelNode-audio-strip span {\n  display: inline-flex;\n  width: auto;\n  min-width: 34px;\n  gap: 3px;\n  padding: 0 6px;\n  background: #c56c1b;\n}\n\n.ModernVideoModelNode-audio-handle {\n  background: #c56c1b !important;\n}\n\n.ModernVideoModelNode-field {\n  display: grid;\n  grid-template-columns: 78px minmax(0, 1fr);\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n}\n\n.ModernVideoModelNode-field > span {\n  color: #59616e;\n  font-size: 12px;\n  font-weight: 680;\n}\n\n.ModernVideoModelNode-field select {\n  width: 100%;\n  height: 34px;\n  padding: 0 30px 0 10px;\n  border: 1px solid #d9dde4;\n  border-radius: 8px;\n  outline: 0;\n  background: #fff;\n  color: #252c37;\n  font-size: 12px;\n}\n\n.ModernVideoModelNode-field select:focus {\n  border-color: var(--video-accent);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--video-accent) 11%, transparent);\n}\n\n.ModernVideoModelNode-duration-field {\n  align-items: start;\n}\n\n.ModernVideoModelNode-duration-field > span {\n  padding-top: 5px;\n}\n\n.ModernVideoModelNode-duration-control {\n  min-width: 0;\n}\n\n.ModernVideoModelNode-duration-slider-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.ModernVideoModelNode-duration-slider {\n  width: 100%;\n  min-width: 0;\n  height: 22px;\n  margin: 0;\n  appearance: none;\n  outline: 0;\n  background: transparent;\n  cursor: pointer;\n}\n\n.ModernVideoModelNode-duration-slider::-webkit-slider-runnable-track {\n  height: 5px;\n  border-radius: 999px;\n  background: linear-gradient(\n    to right,\n    var(--video-accent) 0%,\n    var(--video-accent) var(--duration-progress),\n    #dfe3e8 var(--duration-progress),\n    #dfe3e8 100%\n  );\n}\n\n.ModernVideoModelNode-duration-slider::-webkit-slider-thumb {\n  width: 16px;\n  height: 16px;\n  margin-top: -5.5px;\n  appearance: none;\n  border: 3px solid #fff;\n  border-radius: 50%;\n  background: var(--video-accent);\n  box-shadow: 0 0 0 1px var(--video-accent), 0 2px 5px rgba(31, 42, 57, 0.18);\n}\n\n.ModernVideoModelNode-duration-slider::-moz-range-track {\n  height: 5px;\n  border-radius: 999px;\n  background: #dfe3e8;\n}\n\n.ModernVideoModelNode-duration-slider::-moz-range-progress {\n  height: 5px;\n  border-radius: 999px;\n  background: var(--video-accent);\n}\n\n.ModernVideoModelNode-duration-slider::-moz-range-thumb {\n  width: 10px;\n  height: 10px;\n  border: 3px solid #fff;\n  border-radius: 50%;\n  background: var(--video-accent);\n  box-shadow: 0 0 0 1px var(--video-accent), 0 2px 5px rgba(31, 42, 57, 0.18);\n}\n\n.ModernVideoModelNode-duration-slider:focus-visible::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px var(--video-accent), 0 0 0 4px color-mix(in srgb, var(--video-accent) 16%, transparent);\n}\n\n.ModernVideoModelNode-duration-slider:focus-visible::-moz-range-thumb {\n  box-shadow: 0 0 0 1px var(--video-accent), 0 0 0 4px color-mix(in srgb, var(--video-accent) 16%, transparent);\n}\n\n.ModernVideoModelNode-duration-value {\n  min-width: 48px;\n  padding: 4px 7px;\n  border: 1px solid color-mix(in srgb, var(--video-accent) 25%, #dfe3e8);\n  border-radius: 7px;\n  background: var(--video-soft);\n  color: var(--video-accent);\n  font-size: 11px;\n  font-weight: 750;\n  line-height: 1.2;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.ModernVideoModelNode-duration-limits {\n  display: flex;\n  justify-content: space-between;\n  margin-top: -1px;\n  padding-right: 58px;\n  color: #9299a4;\n  font-size: 9px;\n  line-height: 1;\n}\n\n.ModernVideoModelNode-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  padding: 9px 10px;\n  border: 1px solid #dfe2e7;\n  border-radius: 9px;\n  background: #f4f5f6;\n  color: #3e4652;\n  font-size: 12px;\n  font-weight: 680;\n  cursor: pointer;\n}\n\n.ModernVideoModelNode-toggle input {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  accent-color: var(--video-accent);\n}\n\n.ModernVideoModelNode-hint {\n  display: flex;\n  align-items: flex-start;\n  gap: 7px;\n  padding: 9px 10px;\n  border-left: 3px solid color-mix(in srgb, var(--video-accent) 82%, #fff);\n  border-radius: 7px;\n  background: var(--video-soft);\n  color: #58606c;\n  font-size: 10px;\n  line-height: 1.45;\n}\n\n.ModernVideoModelNode-hint i {\n  flex: 0 0 auto;\n  color: var(--video-accent);\n}\n\n.ModernVideoModelNode-error {\n  padding: 8px 10px;\n  border: 1px solid #ffd0cd;\n  border-radius: 8px;\n  background: #fff2f1;\n  color: #b42318;\n  font-size: 11px;\n}\n\n.ModernVideoModelNode-generate {\n  display: inline-flex;\n  min-height: 43px;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: 0;\n  border-radius: 10px;\n  background: linear-gradient(135deg, color-mix(in srgb, var(--video-accent) 96%, #fff), color-mix(in srgb, var(--video-accent) 88%, #283744));\n  box-shadow: 0 8px 18px color-mix(in srgb, var(--video-accent) 17%, transparent);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 760;\n  cursor: pointer;\n}\n\n.ModernVideoModelNode-generate:hover:not(:disabled) {\n  filter: brightness(0.97) saturate(1.04);\n  transform: translateY(-1px);\n}\n\n.ModernVideoModelNode-generate:disabled,\n.ModernVideoModelNode-field select:disabled,\n.ModernVideoModelNode-duration-slider:disabled {\n  cursor: not-allowed;\n  opacity: 0.58;\n}\n\n.ModernVideoModelNode-duplicate {\n  position: absolute;\n  z-index: 4;\n  top: -12px;\n  right: -12px;\n  display: grid;\n  width: 28px;\n  height: 28px;\n  place-items: center;\n  border: 1px solid #dfe3e8;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 5px 14px rgba(25, 31, 43, 0.15);\n  color: #505966;\n  cursor: pointer;\n}\n\n.ModernVideoModelNode-handle {\n  width: 11px !important;\n  height: 11px !important;\n  border: 2px solid #fff !important;\n  background: var(--video-accent) !important;\n  box-shadow: 0 0 0 1px color-mix(in srgb, var(--video-accent) 36%, #d2d7de);\n}\n\n.ModernVideoModelNode-handle-label {\n  position: absolute;\n  top: 50%;\n  right: 13px;\n  width: max-content;\n  padding: 3px 7px;\n  transform: translateY(-50%);\n  border: 1px solid #dce1e7;\n  border-radius: 7px;\n  background: #fff;\n  color: #59616e;\n  font-size: 10px;\n  font-weight: 720;\n  cursor: pointer;\n}\n\n.ModernVideoModelNode-spinner {\n  width: 13px;\n  height: 13px;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: ModernVideoModelNode-spin 0.8s linear infinite;\n}\n\n@keyframes ModernVideoModelNode-spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
